import { Component, OnInit, OnChanges, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import * as moment from 'moment';
import DataSource from 'devextreme/data/data_source';
import { LanguageService } from '../../../../../../shared/services/language.service';
import { TimeService } from '../../../../_api/services/time.service';
import { EmployeePortalService } from '../../../../../employee/_api/services/employee-portal.service';
import { AmsNotifierService } from '../../../../../../shared/services/ams-notifier.service';
import { ProjectService } from '../../../../../project/_api/services/project.service';
import { TransportService } from "src/app/_api/services/transport.service";

@Component({
  selector: 'app-edit-transport',
  templateUrl: './edit-transport.component.html',
  styleUrls: ['./edit-transport.component.css']
})
export class EditTransportComponent implements OnInit, OnChanges, OnDestroy {

  @Input() transport: any;
  @Input() employees: any;
  @Input() projects: any;
  @Input() newStatusId: number = 3;
  @Input() newCategoryId: number = 8;
  @Output() refresh = new EventEmitter();

  timeTypeDataSource: any;
  equipmentDataSource: any;
  lblNoOfTrips: string;
  isLoadIndicatorVisible = false;
  placeholderProjectSelectSearch = this.languageService.LNG("Label.MinThreeCharacters");

  projectsDataSource: any;
  customerPopupDataSource: DataSource;
  projectsPopupDataSource: DataSource;
  popupVisibleProjectSearch = false;
  projectIdsDataSource: any[];
  selectedProjectIdPopup: number;
  selectedCustomerIdPopup: number;
  selectedProjectItemPopup: any;
  projectPopupSearchEnabled = true;
  isEditingPrimaryProject = false;
  isEditingDisabled = false;

  isNewTransport = false;
  isNewTransportCreated = false;

  refreshIsRquired = false;

  constructor(public languageService: LanguageService,
    private timeService: TimeService,
    private employeePortalService: EmployeePortalService,
    private amsNotifierService: AmsNotifierService,
    private projectService: ProjectService,
    private transportService: TransportService) {}

  ngOnInit() {
    this.setLookUps();
  }

  async ngOnDestroy() {
    if (this.refreshIsRquired) { this.refresh.emit(); }
    if (!this.isNewTransportCreated || this.transport.Times?.length > 0) { return; }
    await this.transportService.deleteTransportCollection(this.transport.TransportCollectionId).toPromise();
  }

  ngOnChanges() {
    this.lblNoOfTrips = this.languageService.LNG("Label.NumberOf") + " " + this.languageService.LNG("Label.Trips");
    this.isEditingDisabled = this.transport?.TransportStatusId >= 4;
    this.isNewTransport = this.transport === null;
    this.isNewTransportCreated = false;

    if (this.isNewTransport) {
      this.transport = {
        TransportTypeName: this.languageService.LNG("Label.Transport"),
        TransportId: null,
        TransportCollectionId: null,
        TransportStatusId: this.newStatusId,
        TransportCategoryId: this.newCategoryId,
        Date: new Date(),
        EmployeeId: null,
        PrimaryProjectId: null,
        SecondaryProjectId: null,
        CustomerReference: "",
        Comment: "",
        TransportTrips: []
      };
    }
  }

  onLoading(loading: boolean) {
    this.isLoadIndicatorVisible = loading;
  }

  getTimeTypes() {
    this.timeService.getTimeTypes()
      .subscribe((result: any) => {
        this.timeTypeDataSource = result;
      }, error => {
    });
  }

  getEquipment() {
    this.timeService.getEquipment()
      .subscribe((result: any) => {

        this.equipmentDataSource = result.Data;
      }, error => {
    });
  }

  getEmployees(): Promise<boolean> {
    const from = moment().format('DD.MM.YYYY');

    return new Promise(resolve => {
    this.employeePortalService.getEmployeesNotQuit(from)
      .subscribe((result: any) => {

        this.employees = result;
        resolve(true);
      }, error => {
        resolve(false);
      });
    })
  }

  async onSaveHeader(e: any) {
    const date = this.transport.Date;
    const employeeId = this.transport.EmployeeId;
    const primaryProjectId = this.transport.PrimaryProjectId;
    const secondaryProjectId = this.transport.SecondaryProjectId;
    const customRef = this.transport.CustomerReference ?? "";
    const comment = this.transport.Comment ?? "";

    this.isLoadIndicatorVisible = true;

    const response = this.isNewTransport
      ? await this.createTransport(date, employeeId, primaryProjectId, secondaryProjectId, customRef, comment)
      : await this.updateTransport(date, employeeId, primaryProjectId, secondaryProjectId, customRef, comment);

    this.isLoadIndicatorVisible = false;

    if (!response.IsSuccess) {
      this.amsNotifierService.error(response.ErrorMessage);
      return;
    }

    this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
    this.refresh.emit();

    if (this.isNewTransport) {
      this.isNewTransport = false;
      this.isNewTransportCreated = true;
      this.transport = response.Data;
      this.transport.Times = [];
      this.transport.TransportEquipment = [];
      this.transport.TransportAdditions = [];
      this.transport.TransportExpenses = [];
      this.transport.TransportArticles = [];
    }
  }

  createTransport(date: Date, employeeId: number, primaryProjectId: number, secondaryProjectId: number, customRef: string, comment: string) {
    return this.transportService.createTransportCollection(date, employeeId, primaryProjectId, secondaryProjectId, customRef, comment).toPromise();
  }

  updateTransport(date: Date, employeeId: number, primaryProjectId: number, secondaryProjectId: number, customRef: string, comment: string) {
    return this.timeService.updateTransportCollection(this.transport.TransportCollectionId, date, employeeId, primaryProjectId, secondaryProjectId, customRef, comment).toPromise();
  }

  focusProject(e: any) {
    e.event.target.select();
  }

  setLookUps() {
    // project
    this.projectsDataSource = new DataSource({
      key: "ProjectId",
      paginate: false, //Eirik 11.08.20 v2.0.31.3 task 318 - when paginate is false the list is not updated when scrolling to the bottom. had an issue where the list added the same projects again when the user scrolled to the bottom of the list
      load: (loadOptions) => {

        if (this.projectIdsDataSource && this.projectIdsDataSource.length > 0) {

          this.isLoadIndicatorVisible = true;
          if (loadOptions.searchValue != null) {
            if (loadOptions.searchValue.length >= 3) {
              return this.projectService.getBySearchTextAndProjectIdsVM(loadOptions.searchValue.toString(), this.projectIdsDataSource).toPromise().then((data: any) => {

              this.isLoadIndicatorVisible = false;
                return data;
              });
            }
            else {

              this.isLoadIndicatorVisible = false;
            }
          }
          else {

            return this.projectService.getByIdsVM(this.projectIdsDataSource).toPromise().then((data: any) => {
              this.isLoadIndicatorVisible = false;
              return data;
            });
          }
        }
        else {
          if (loadOptions.searchValue != null && loadOptions.searchValue.length >= 3) {
            return this.timeService.getProjectsBySearchText(loadOptions.searchValue.toString()).toPromise().then((data: any) => {
              this.isLoadIndicatorVisible = false;
              return data;
            });
          }
        }
      },
      byKey: (key) => {

        if (key > 0) {
          return this.timeService.getProjectSearchBoxById(key).toPromise();
        }
        else {
          let p: any = {
            ProjectId: -1,
            CustomerId: -1,
            ProjectNumber: "",
            ProjectDisplayName: ""
          }
          return p;
        }
      }
    });

    //customer popup
    this.customerPopupDataSource = new DataSource({
      key: 'CustomerId',
      loadMode: "raw",
      load: (loadOptions) => {
        return this.timeService.getCustomers().toPromise();
      },
      byKey: (key) => {
        return this.timeService.getCustomer(key).toPromise();
      }
    });

    //project popup
    this.projectsPopupDataSource = new DataSource({
      key: "ProjectId",
      paginate: false, //Eirik 11.08.20 v2.0.31.3 task 318 - when paginate is false the list is not updated when scrolling to the bottom. had an issue where the list added the same projects again when the user scrolled to the bottom of the list
      load: (loadOptions) => {

        if (loadOptions.searchValue != null && loadOptions.searchValue.length >= 3) {
          this.isLoadIndicatorVisible = true;
          return this.timeService.getProjectsBySearchText(loadOptions.searchValue.toString()).toPromise().then((data: any) => {


            this.isLoadIndicatorVisible = false;

            return data;
          });
        }
        else {
          if (this.selectedCustomerIdPopup > 0) {

            this.isLoadIndicatorVisible = true;
            return this.timeService.getProjectsByCustomerId(this.selectedCustomerIdPopup).toPromise().then((data: any) => {


              this.isLoadIndicatorVisible = false;

              return data;
            });
          }
          else {
            return [];
          }
        }
      },
      byKey: (key) => {

        if (key > 0) {
          return this.timeService.getProjectSearchBoxById(key).toPromise();
        }
        else {
          let p: any = {
            ProjectId: -1,
            CustomerId: -1,
            ProjectNumber: "",
            ProjectDisplayName: "",
            CarrierId: -1,
          }
          return p;
        }
      }
    });
  }

  showPopupProject(selectedProjectId: number, isPrimaryProject: boolean) {
    this.isEditingPrimaryProject = isPrimaryProject;
    this.popupVisibleProjectSearch = true;
    this.selectedProjectIdPopup = selectedProjectId ? selectedProjectId : -1;

    if (selectedProjectId <= 0 || !selectedProjectId) {
      this.selectedCustomerIdPopup = -1;
    }
  }

  onPopupCustomerChanged(e: any) {
    this.projectPopupSearchEnabled = false;
    this.selectedCustomerIdPopup = e.value;
    this.projectsPopupDataSource.reload();
  }

  onPopupProjectChanged(e: any) {
    this.selectedCustomerIdPopup = e.selectedItem.CustomerId;
    this.selectedProjectItemPopup = e.selectedItem;
  }

  //when ok is clicked, then set cellvalue using setValue and also set cell.data so that the correct data is displayed in the selectbox
  onClickPopupSelectedProject(e: any) {
    this.popupVisibleProjectSearch = false;

    if (this.isEditingPrimaryProject) {
      this.transport.PrimaryProjectId = this.selectedProjectItemPopup.ProjectId;
    } else {
      this.transport.SecondaryProjectId = this.selectedProjectItemPopup.ProjectId;
    }
  }
}
